import { render } from "./QueueViewPage.vue?vue&type=template&id=e600a0e0&scoped=true"
import script from "./QueueViewPage.vue?vue&type=script&lang=js"
export * from "./QueueViewPage.vue?vue&type=script&lang=js"

import "./QueueViewPage.vue?vue&type=style&index=0&id=e600a0e0&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e600a0e0"]])

export default __exports__